var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe800",
    fillRule: "evenodd",
    d: "M.7 0H54v40H.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00148e",
    fillRule: "evenodd",
    d: "M.7 20H54v20H.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0010",
    fillRule: "evenodd",
    d: "M.7 30H54v10H.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m23.1 24.2-6 6.4-.1-.1zm4.2 1-7.9 8.4-.1-.1 7.9-8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.5 33.5-.8.7-.8.7.6-.9.8-.7zm-2.1-3.2-.7.7-.9.6.7-.8.7-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18 9.6s-.7 18 2 18c2.6 0 4-2 4-2v-9.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.6 11.2c0 1-.3 14.4 1 14.4s3.4-1 3.4-1v-8.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.5 12.1c0 1 .1 11.6 1.5 11.6h2v-8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m17.9 9.7 6 6.3-6-6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16 13.2s-1.7 17.4 3.4 17.4c4.3 0 4.3-2.7 5.2-2.7l-.9-6.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M20.3 16.1s1.3-2.8 4.5-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M19.7 13.5q.7.3 1 .7-.7 0-1.2-.3l-1-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "m20.9 15.2-.1.2h-.2v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "m22.3 11.7-.7 1.1.4-1.3.7-1.2zm-.7 0-.2 1.2v-1.2l.2-1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "m22 12.2-.6.6q.2-.6.6-1t.7-.5zm-2.1.5q.4.5.5 1-.5-.2-.9-.7l-.6-1.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m19.3 15.4.7 1-1.1-.6q-.6-.5-.8-1zm1.7-.1q-.4.7-1 1l.6-1.2 1-1.2q0 .6-.6 1.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m21.4 15.3-1.4.6 1.1-1 1.4-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "m24.6 11.8-.6.5.5-.7.6-.5zm-.5-.8q0 .4-.4.7zl.4-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "m24.9 11.5-.6.2.6-.4.5-.2zM22 12.9l-1 .5q.3-.4.8-.7l1.1-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23 13.2-1.3.6 1.1-1 1.5-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.7 18.1s-.3-2.7 1.7-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "m22.8 12.5-.1.2h-.2v-.2zm.9-.5-.1.2h-.2V12zm-2.6 1.8h-.2v-.1zm.3-.1H21l.1-.2zm-.1.3H21zm.4 0h-.3l.1-.2zm.3-.3q0 .2-.2.2h-.2l.1-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "m22 13.8-.1.2h-.2v-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M17.7 15c0 1-1.7 11 2.6 13.8 1.7 1 4.3-1 4.3 0l-.9-7.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M19.4 17c0 .8-.8 8.1 1.8 10 1.7 1.8 6 1.3 6 1.3l-3.5-6.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m16 13.2 7.9 8.3.1-.1-7.9-8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    fillRule: "evenodd",
    d: "M14.8 12.2h.5l.1.2q.1 0 0 .4c-.2.2-.5-.1-.5-.1l.3.8q.6.3.7.2s-.3-.3-.1-.5q.4-.1.4 0l.3.2.2-.2-1.2-1.1-.1-.5-.8-.2zM16 8.7l.5 1 .8.1-.5.3h1l.3.3.2-.2-.4-.3-.4-1v.7l-.5-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m18.4 9.2-.1.1H18q0-.2.2-.2zm-.2.2c0 1 .7 4.7.7 4.8q0 .2-.2 0c-.2-.4-.7-4-.7-4.8q0-.5.3-.3.2 0 .3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M18.7 10.1h-.3l.2-.1zm-.3.2c.2 1.8-.6 4.5-.6 4.7h-.2c0-.2.9-2.7.6-4.8q.3-.4.4-.3.3 0 .2.3t-.4 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.2 12.6q0 .2-.2.2l-.1-.2.1-.1zm-.2.4c0 1.4.8 7.8.9 8q0 .2-.3 0a68 68 0 0 1-.9-8q0-.9.4-.7l.3.3q0 .4-.4.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M16.7 13.4h-.3v-.1l.2-.1v.2Zm-.4.2c.2 2.9-.8 7.3-.8 7.5q-.2.3-.3 0c0-.2 1.1-4.2.9-7.6q.3-.6.6-.5l.2.5q-.2.3-.6.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m31.5 24.2 6 6.4.2-.1-6-6.4zm-4.2 1 8 8.4v-.1L27.6 25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m35.2 33.5.7.7.9.7-.6-.9-.8-.7zm2-3.2.8.7.8.6-.6-.8-.8-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.7 9.6s.6 18-2 18c-2.7 0-4-2-4-2v-9.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35 11.2c0 1 .3 14.4-1 14.4s-3.3-1-3.3-1v-8.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.2 12.1c0 1-.2 11.6-1.5 11.6h-2v-8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m36.8 9.7-6 6.3h-.1l6-6.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M32 14.6s1.7 2.2 2.6 3.8c.8 1.7 1.7 4.3 1.7 4.3s-.5-2.5-1.5-4.6c-1.4-2.5-2.7-3.4-2.7-3.5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M32 12.9a34 34 0 0 0 4.6 9.6s-.5-2.9-1.6-5.3c-1.4-3-3-4.2-3-4.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.6 10.2A55 55 0 0 0 36 22.5s.3-2.9-.3-5.9c-.7-3.8-2.1-6.3-2-6.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.4 10s1.9 3.6 2.6 6 1.4 5.8 1.4 5.8-.1-3.1-1-6c-1.3-3.8-3-5.6-3-5.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M34.6 11.2a60 60 0 0 0 1.5 11.4s.3-2.5 0-5.3c-.5-3.6-1.5-6-1.5-6.1",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.2 11.3a36 36 0 0 0 4 10.3s-.2-2.9-1.1-5.4c-1.3-3.3-3-4.8-2.9-5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M31.9 13.4a28 28 0 0 0 4.5 8.8s-.4-2.7-1.5-5c-1.4-2.7-3-3.7-3-3.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M32.1 12.3a35 35 0 0 0 4 9.9s-.2-2.9-1.2-5.3c-1.3-3.2-2.8-4.5-2.8-4.6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34 10.3a52 52 0 0 0 1.7 11.9s.4-2.7 0-5.6c-.5-3.8-1.8-6.2-1.7-6.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.5 9.3a46 46 0 0 0 3.3 12s0-3-.7-6c-1-3.9-2.7-5.8-2.6-6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    d: "M35 11.4a54 54 0 0 0 .9 11s.4-2.4.3-5c-.3-3.5-1.2-5.9-1.1-6",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005b00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.3 10.8s1.6 3.2 2.2 5.3c.6 2.2 1 5.3 1 5.3s.1-2.8-.7-5.5c-1-3.3-2.6-5-2.5-5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.6 13.2s1.8 17.4-3.4 17.4C31 30.6 31 28 30.1 28l.8-6.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37 15c0 1 1.6 11-2.6 13.8-1.8 1-4.3-1-4.3 0l.8-7.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.2 17c0 .8.9 8.1-1.7 10-1.7 1.8-6 1.3-6 1.3l3.4-6.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m38.7 13.2-8 8.3v-.1l7.8-8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cececc",
    fillRule: "evenodd",
    d: "M39.9 12.2h-.5l-.2.2.1.4c.2.2.5-.1.5-.1q.1.2-.4.8-.5.3-.6.2s.3-.3 0-.5h-.3l-.3.2-.2-.2 1.2-1.1v-.5l.8-.2zm-1.2-3.5-.6 1-.7.1.5.3h-1l-.4.3-.1-.2.4-.3.3-1 .1.7.5-.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m36.3 9.2.1.1h.2l-.2-.2zm.2.2c0 1-.7 4.7-.8 4.8q0 .2.3 0c.2-.4.7-4 .7-4.8q0-.4-.3-.3-.2 0-.3.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 10.1h.2l-.1-.1zm.3.2c-.2 1.8.5 4.5.5 4.7h.3c0-.2-.9-2.7-.6-4.8q-.2-.4-.5-.3l-.1.3q.1.2.4 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.5 12.6.1.2q.2 0 .2-.2l-.2-.1zm.2.4-1 8q.1.2.4 0c.2-.7.8-6.7.9-8q0-.9-.4-.7-.3 0-.3.3 0 .4.4.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38 13.4h.2q.2 0 .1-.1l-.2-.1zm.4.2c-.3 2.9.8 7.3.8 7.5q.1.3.3 0c0-.2-1.2-4.2-1-7.6q-.2-.6-.5-.5-.2.2-.2.5.2.3.6.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24.6 35.2a2 2 0 0 0 2.6 0V28h-1.8c.9 2.7.9 5.5-.8 7.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M26 28c0 5.2-1.3 6.4-1.3 7.4q.8-.1 1.2-1.1c.6-1 .6-6.3.6-6.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25 28c-.1 3-1.4 5.9-1.2 6.5.3.5 1.1-1.3 2.1-.3.6-1 .6-6.2.6-6.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25 27.6c0 3.4-1.2 3.6-1.2 4.5.6 0 1.2-.5 1.2-.4.5-.7.6-4.1.5-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M24 27.6c0 2-1.3 3.7-1 4 .2.4 1-.6 2 0 .5-.6.6-4 .5-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e10000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30 35.2a2 2 0 0 1-2.5 0V28h1.7c-.8 2.7-.8 5.5.9 7.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.7 28c0 5.2 1.3 6.4 1.3 7.4q-.8-.1-1.3-1.1a27 27 0 0 1-.5-6.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000c4",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.8 28c0 3 1.3 5.9 1 6.5s-1-1.3-2-.3a27 27 0 0 1-.6-6.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.6 27.6c0 3.4 1.2 3.6 1.2 4.5-.5 0-1.2-.5-1.2-.4-.5-.7-.5-4.1-.5-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.7 27.6c0 2 1.2 3.7 1 4-.3.4-1-.6-2 0-.6-.6-.6-4-.6-4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m20.8 28.5-.9.6.9.7.5-.4.2.4.2.6.2-.6.2-.4h12v-.6h-12l-.2-.3q0-.6.2-.7h1c0-.3-.5-1-1.4-1s-1.3.7-1.3 1h.9q.2 0 .2.7l-.2.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b74d00",
    fillRule: "evenodd",
    d: "M23.4 30h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9zm0-.4h7.9v.4h-7.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.3 30h-7.9v.4h7.9zm0 0v-.4h-7.9v.4zm0-.8h-7.9v.4h7.9zm0 0v-.4m0 .4h-7.9v-.4h7.9m0 0v-.4m0 .4h-7.9v-.4h7.9m0 0V28m0 .4h-7.9V28h7.9m0 0v-.4h-7.9v.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23.8 27.6 2.9 2.8h.4l-2.9-2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m23.8 30.5 2.9-2.8h.4l-2.9 2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M23.9 27.6v2.8h.4v-2.8zm3.6 0 2.9 2.8h.4l-2.9-2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.5 30.5 2.9-2.8h.4l-2.9 2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#908f8a",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M30.5 27.6v2.8h.4v-2.8zm-2.9 0v2.8h.4v-2.8zm-.8 0v2.8h.4v-2.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.1 19.7c0 4.5-2.6 8.2-6 8.2-3.3 0-6-3.7-6-8.2 0-4.6 2.7-8.3 6-8.3 3.4 0 6 3.7 6 8.3Zm-.8 0c0 4-2.3 7.3-5.1 7.3-2.9 0-5.2-3.3-5.2-7.3s2.3-7.4 5.2-7.4c2.8 0 5 3.3 5 7.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M29.5 12q-1-.6-2.3-.6t-2.4.7l.4.8a4 4 0 0 1 4 0zm0 15q-1 .6-2.3.7t-2.4-.7l.4-.8a4 4 0 0 0 4 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7cfff",
    fillRule: "evenodd",
    d: "M32.3 19.7c0 4-2.3 7.3-5.1 7.3-2.9 0-5.2-3.3-5.2-7.3s2.3-7.4 5.2-7.4c2.8 0 5.1 3.3 5.1 7.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#afff7b",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M32.3 19.7c0 1.3-.2 2-.6 3.4 0 .2-.5-.3-.8-.5-.2-.3-.4.2-.7-.2s-.5.1-.8-.2c-.2-.3-2.4-.4-2.4-.4.2-.1 1.3 0 1.1-.6s-1.5 0-1.6-.8-2.6-.8-2.8-1c0 .3 2 .4 1.9 1.2 0 .3-1.8.4-2 .6-.2.4 1.4 0 1.4.4l-1 .2c-.4.1.8.5.3.8L23 23c.1.4 2.2 1 2 1l-1.5.8a9 9 0 0 1-1.5-5.1c1.6-.6 1.2-.8 4-.8 2.9 0 3.8.2 6.3.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m32.3 19.7-1.2.1-1.3-.1-1.4.2-1.3-.2-1.3.1-1.3-.1-1.3.1-1.2-.1q0-1.5.4-2.9c1.3.1.6-.8 1.3-.8a2 2 0 0 1 1.3.5s.6-.6 1.3-.5c.6 0 .4 1.4 1.3 1.5q.5.4 1.3.7h3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m28 24 .2-.8q0-.4-.3-.7 0-.3.3-.3l.1.3-.1-.1H28l.2.8-.2.7v.5-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.7 23.9q-.2-.2-.3-.8l.2-.7-.2-.2-.2.3.1-.2.3.1q-.2.2-.2.8l.2.7-.1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m28.4 22-.1.3-.1-.2v-.2q.3 0 .2.2m1.4.8v1.6zm.4-.1v1.6zm-.2.6h.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b74d00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.3 24s1.2.5 1.5.8l.2.4 2.8.1c0-.2.5-.2.6-.6v-.5l-.8.3V24H29l-.1.5H27l.2-1.5h-.4v1.4l-1.6-.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fede00",
    fillRule: "evenodd",
    stroke: "#fede00",
    strokeWidth: 0.1,
    d: "M22.8 15.5s1.8-.6 4.4-.5 4.5.6 4.4.6l-.5-1s-1.8-.5-4-.5c-2 0-3.8.4-3.8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38a9f9",
    fillRule: "evenodd",
    d: "M26.2 14.2h1.1v.6h-1.1zm-2.6.3-.4.7 1.3-.2v-.6zm1.1-.2 1.1-.1v.6l-1 .1zm4-.1h-1v.6h1zm2.5.4.4.8-1.2-.3.1-.6zm-1-.2-1-.2-.2.7 1.2.1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.2 15.9-.1-.7-.4.6.2-.7-.6.4.4-.6-.7.1.6-.4-.7-.1.7-.1-.6-.4.7.1-.4-.6.6.4-.2-.7.4.6.1-.7.1.7.4-.6-.1.7.5-.4-.4.6.7-.1-.6.4.7.1-.7.1.6.4-.7-.1.4.6-.5-.4.1.7-.4-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M28.2 14q0 .7-.7.8a.7.7 0 1 1 .7-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m27.4 14.2-.2.1h-.3q0-.2.3-.2zm.5 0-.2.1h-.2l.2-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m27.4 14.5.1.2.2-.2m-.8.4.2.1q.3 0 .5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7e1ff",
    fillRule: "evenodd",
    d: "M24.1 16.2q.2.1-.4 1.5l-.4.6.2.4-.4-.4-.5.5.4-.7-.1-.3.3-.1.4-.8-1.3 1zm.3.3.4 1q.3.6.2.7l.7.4-.9-1.3.6.2zm0 1.7s.5.5.5.7v.5l-.1-.4-.3.4.2-.6-.3.2zm-2.3 1.2.5-.2-.3.3zm5.3-1.8 1 .6-.6-.3zm-1.8-1.3 1.5 1.2-.7-.3v.3l-.3-.7v.3zM26 18l.4.8h.4zm1.2-.5v.8l.2.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#984000",
    fillRule: "evenodd",
    d: "M15.9 7.5s1.7-1 3.7-1.7q2.3-.9 4.5-1.2c.6 0 1.6 1.5 1.8 1.5s.9-.5 1.7-.5 1.3.7 1.5.7h1.5c.2 0-.5-1.6 0-1.6.3 0 2.4.4 4.4 1l5 2s-4.7.6-5.9.4c-.2 0 0 1-.2.6l-2.1-.3-1.4.5-1.5.4 1 1.7-1.3.7s-.8-2-1.2-2-.5 1.4-.9 1.3-.6-1.3-1-1.6c-.2-.4-2-.5-2.7-.6l-2.3-.5c-.6-.2-1.2.4-1.5.4-.2 0 .4-.5.1-.6l-.6.3-2-.4c-.3-.1.3-.4.2-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    stroke: "#772600",
    strokeWidth: 0.1,
    d: "M28.5 6.6q0 .8-.9.9a1 1 0 0 1-.8-.9q0-.7.8-.8.8.1.9.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#984000",
    fillRule: "evenodd",
    stroke: "#772600",
    strokeWidth: 0.2,
    d: "M24.2 6.8q.1-.4.8-.5 0-.2.4-.3.3.1.4.4l1.7-.1.1.3-.1.3h-2.1l-.5-.3q-.2-.1-.7.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#772600",
    strokeWidth: 0.1,
    d: "M28.8 6.7h2.1q.4 0 .1-.3l-.1-.3-.2-.6V5q0 .3.3.2l.5.1q.1.2.4.1l.4.2q.1.2.5.2l.4.1.5.2h.8l.4.2.5.2h.6l.4.2.5.2h.5q.2.3.4.2l.5.2.4.1q.2 0-.1.1H38q-.1-.2-.4-.2l.2.3h-.6l-.4-.1h.4q0 .3-.3.2l-.5-.2H36q.2 0 .4.3h-.1l-.5-.2h-.5q-.2-.2.1 0t.2.3l-.4-.2-.5-.1.1.1q.3.2-.1.1l-.5-.2H34q.2 0 .3.2.2.2-.2 0l-.3-.3q-.3-.2 0 0V8l-.3-.2-.4-.3-.3-.1.4.5q.2 0 .4.3 0 .1 0 0l-.5-.3-.4-.3q-.2-.2 0 0l.4.5.3.4q.2 0 0 0l-.4-.2-.4-.3q0-.3-.3-.4-.1-.1 0 .2l.2.4q0 .1-.2 0-.2-.3-.5-.3h-.5l.2.2c.2.2-.2 0-.3 0h-.5q-.3 0 0 .2v.2h-.9v.1l.3.2H29l.1.2q0 .2-.3.1l-.4-.1h-.2l.4.3m-2.5 1.5-.1-.3-.2-.3v-.5q-.2-.1-.3-.4-.2-.3 0-.8L25 9v-.6c-.1-.4-.3.2-.4.4h-.3v-.6l-.6.5V8l-.4.7V8l-.4.5q-.2-.2 0-.6c0-.2-.2.4-.3.4l-.3.2.4-.6-.7.4h-.3l.5-.5q-.4 0-.7.4H21l.4-.7-.5.2q0 .2 0 0l.1-.3-.4.2-.5.4-.7.4q-.2 0-.3.2 0-.3.3-.5.1-.2.4-.3v-.1l-.4.3-.3.1q0-.2.3-.4h-.2l-.4.3-.4.2V8l.4-.3-.4.3H18q-.3 0 0 0 .3-.2.3-.4l-.5.4h-.4l.3-.3q0-.2-.2 0h-.6q0 .2.1 0l.2-.2-.3.2-.3.1.3-.3q.3 0 .3-.2h-.5.9q.3 0-.2-.1l.2-.1.4-.2.3-.2H18h.5l.4-.2q.2-.1 0-.1l.5-.1.4-.2.3-.3.4.2.5-.2.3-.2h.6l.5-.2.3-.2.4.1.5-.1q0-.2.3-.3t.3.2l.4.1q0 .3.3.4l.3.2.2.2.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#782600",
    strokeWidth: 0.1,
    d: "M28.3 9.6v.5l-.1.3-.2.2v-.1l-.2-.3-.1-.3-.2-.2v-.2h-.6v.4q-.2 0-.2.2v.4q-.2 0-.2.2H26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#812e00",
    fillRule: "evenodd",
    d: "m26.3 10.5-.3.7-.8.5s.7-.3.8-.2l-.5.7.8-.7.4.6-.1-.9v-.8zm1.7 0-.3.6-.8.7s.7-.4.8-.3l-.5.7.9-.7.3.7-.1-1v-.8zm-2.4-4h-.2l-.1-.1.1-.2z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.edca65dec4ac10d270145821065f40ff.svg";
export { ForwardRef as ReactComponent };